import { useBienContext } from '../BienContext'

import { EyeIcon } from '@heroicons/react/24/solid'
import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { Input, Toggle } from '@/components/ui'
import { formatDate } from '@/utils/formatters'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'diagnostics'
  const SECTION_TITLE = 'Diagnostics'

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les diagnostics"
  />

  // const InputDisplayFile = ({item, label, name, title}) => {

  //   const file = item ? item[name] : null

  //   const handleClick = (e) => {
  //     e.preventDefault()
  //     e.stopPropagation()
  //     window.open(file.url , '_blank')
  //   }

  //   return (
  //     <div className="flex items-center justify-between">
  //       <Input.Display label={label} 
  //         className="flex items-center mb-2 w-full max-w-9/10"
  //         labelClassName="" 
  //         valueClassName="overflow-hidden max-w-3/4 text-nowrap"
  //       >
  //         { file?.filename ?
  //             file?.url ? 
  //               <button title={`Voir ${title}`} className="flex cursor-pointer" onClick={handleClick}>
  //                 <span>{file.filename}</span>
  //               </button> :
  //               <span>{file.filename}</span> :
  //               null
  //         }
  //       </Input.Display>
  //       <div className="flex mb-2 ml-2 mr-4">
  //         { !!file?.url && (
  //           <button 
  //             onClick={handleClick}
  //             className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
  //             title={`Voir ${title}`} aria-label={`Voir ${title}`}
  //           >
  //             <EyeIcon/>
  //           </button>
  //         )}
  //       </div>
  //     </div>
  //   )
  // }

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
       <div className="space-y-4">
         <div className="space-y-4">
           <Input.Display label="DPE note" value={bien.diagnostic_dpe_note} valueClassName="uppercase" />
           <Input.Display label="DPE date" value={formatDate(bien.diagnostic_dpe_date)} />
           <Input.Display label="DPE date d'échéance" value={formatDate(bien.diagnostic_dpe_date_echeance)} />

           <Input.DisplayFile label="DPE fichier" title="le diagnostic DPE" 
             item={bien} name="diagnostic_dpe_file"
           />

         </div>
         <div className="space-y-4">
           <Input.Display label="Gaz date" value={formatDate(bien.diagnostic_gaz_date)} />
           <Input.Display label="Gaz date d'échéance" value={formatDate(bien.diagnostic_gaz_date_echeance)} />
           <Input.DisplayFile label="Gaz fichier" title="le diagnostic Gaz" 
             item={bien} name="diagnostic_gaz_file"
           />
         </div>
         <div className="space-y-4">
           <Input.Display label="Elec. date" value={formatDate(bien.diagnostic_electricite_date)} />
           <Input.Display label="Elec. date d'échéance" value={formatDate(bien.diagnostic_electricite_date_echeance)} />
           <Input.DisplayFile label="Elec. fichier" title="le diagnostic Elec." 
             item={bien} name="diagnostic_electricite_file"
           />
         </div>
       </div>
       <div className="space-y-4">
         <div className="space-y-4">
           <Toggle.Display label="Plomb" value={bien.diagnostic_plomb} />
           <Input.Display label="Plomb date" value={formatDate(bien.diagnostic_plomb_date)} />
           <Input.Display label="Plomb date d'échéance" value={formatDate(bien.diagnostic_plomb_date_echeance)} />
           <Input.DisplayFile label="Plomb fichier" title="le diagnostic plomb" item={bien} name="diagnostic_plomb_file" /> :
         </div>

         <div className="space-y-4">
           <Toggle.Display label="Amiante" value={bien.diagnostic_amiante} />
           <Input.Display label="Amiante date" value={formatDate(bien.diagnostic_amiante_date)} />
           <Input.Display label="Amiante date d'échéance" value={formatDate(bien.diagnostic_amiante_date_echeance)} />
           <Input.DisplayFile label="Amiante fichier" title="le diagnostic amiante" 
             item={bien} name="diagnostic_amiante_file"
           />
         </div>
       </div>
      <div className="space-y-4">
        <Toggle.Display label="Zone permis de louer" value={bien.zone_permis_louer} />
        <Toggle.Display label="Permis de louer effectué" value={bien.permis_louer} />
        <Input.Display label="Permis de louer date" value={formatDate(bien.permis_louer_date)} />
        <Input.DisplayFile label="Permis louer fichier" title="la zone permis de louer" 
          item={bien} name="permis_louer_file"
        />

        { bien.type_bien === 'immeuble' && <Input.Display label="Audit énergie" value={bien.audit_energie} valueClassName="uppercase" /> }
        { bien.type_bien === 'immeuble' && 
          <Input.DisplayFile label="Audit énergie fichier" title="l'audit d'énergie" 
            item={bien} name="audit_energie_file"
          />
        }
      </div>

    </DetailTemplate>
  )
}